<template>
  <div class="future-coahings futcchng">
    <div
      v-if="!l_items.length"
      class="futcchng_empty-message f-center f-column w-100 clr-grey weight_500 pa-16 text-center"
    >
      <i class="mdi mdi-message text-big"></i>
      {{ $t('messages.no_coachings') }}
    </div>
    <!-- <div v-else class="futcchng_time-message">
      {{ $t(`coachings.time_message`) }}
    </div> -->
    <FutureCoachingsBox
      v-for="(item, idx) in l_items"
      :key="idx"
      class="mt-4"
      :item="item"
    />
  </div>
</template>

<script>
import FutureCoachingsBox from '@/components/lib/FutureCoachingsBox'

export default {
  name: 'VideoList',
  components: {
    FutureCoachingsBox,
  },
  props: {
    items: { default: () => [] },
  },
  data() {
    return {}
  },
  mounted() {},

  computed: {
    l_items() {
      let res = this.items.filter(i => {
        const r = !i.is_past
        // const r = i.is_past
        return r
      })
      res = res.sort((a, b) => (a.datetime < b.datetime ? -1 : 1))
      res = import.meta.env.VITE_BRANCH === 'master' ? res : res.length ? res : [this.items[0]]

      // console.log(res)
      return res
    },
  },
}
</script>
<style lang="scss" scoped>
.futcchng {
  width: 100%;

  max-width: 58rem;
  &_item {
  }
  &_time-message {
    color: var(--clr-grey-2);
    font-size: 0.875rem;
    text-align: right;
  }
}

// @media (min-width: 3440px) {
// .futcchng {
// max-width: 1980px;
// }
// }
</style>
